import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker as Date } from '@mui/x-date-pickers/DatePicker';
import Typography from '../typography/typography';
import { styled } from '@mui/material';
import logo from '../../assets/images';
import './date-picker.scss';
import dayjs from 'dayjs';
import { memo } from 'react';

export interface DatePickerProps {
	label: string;
	disabled?: boolean;
	error?: boolean;
	name?: string;
	value?: string | number | Date;
	helperText?: string;
	dataPosition?: number;
	dataName?: string;
	disableFutureDates?: boolean;
	placeholder?: string;
	required?: boolean;
	disablePastDates?: boolean;
	defaultValue?: string | number | Date | undefined;
	textFieldProps?: any;
	format?: string;

}

const StyledDatePicker = styled(Date)(({ theme: { palette } }) => ({
	'& .MuiOutlinedInput-root': {
		padding: '0',
		color: palette.theme?.secondary[800],
		'& fieldset': {
			borderColor: palette.theme?.secondary[400]
		},
		'&:hover fieldset': {
			borderColor: palette.theme?.secondary[500]
		},
		'&.Mui-focused fieldset': {
			borderWidth: '0.0625rem',
			borderStyle: 'solid',
			borderColor: palette.theme?.primary[700]
		},
		'&.Mui-error fieldset': {
			borderColor: palette.theme?.error[600]
		},
		'&.Mui-disabled': {
			background: palette.theme?.secondary[200],
			color: palette.theme?.secondary[800]
		},
		'& .MuiInputBase-input::placeholder': {
			color: palette.theme?.secondary[800],
			opacity: 1
		}
	},
	'& .MuiFormHelperText-root': {
		marginLeft: 0,
		color: palette.theme?.secondary[800],
		'&.Mui-error': {
			color: palette.theme?.error[600]
		}
	},
	'& .MuiIconButton-root': {
		marginRight: 0
	},
	'& .MuiPickersCalendarHeader-labelContainer': {
		fontWeight: 600
	}
}));

const DatePicker = memo((props: DatePickerProps) => {
	const {
		label,
		disabled,
		error,
		helperText,
		dataName,
		dataPosition,
		disableFutureDates = false,
		placeholder,
		required = false,
		disablePastDates = false,
		defaultValue,
		textFieldProps,
		format,
		...rest
	} = props;

	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{label && (
				<Typography
					type='s5'
					weight='medium'
					mb={0.5}
					color={error ? 'theme.error.600' : 'theme.secondary.800'}
					data-position={dataPosition}
					data-name={dataName}>
					{label} {required && <span className='requiredStar'>*</span>}
				</Typography>
			)}
			<StyledDatePicker
				disabled={disabled}
				disableFuture={disableFutureDates}
				disablePast={disablePastDates}
				slotProps={{
					textField: {
						helperText: helperText,
						error: error,
						placeholder: placeholder || 'MM/DD/YYYY',
						...textFieldProps
						// required: required,
					},
					desktopPaper: {
						sx: {
							'& .MuiButtonBase-root.Mui-selected': {
								color: 'theme.primary.900',
								bgcolor: '#B6E9D6 !important'
							},
							'& .MuiButtonBase-root:hover': {
								color: 'theme.primary.900',
								bgcolor: '#B6E9D6 !important'
							}
						}
					}
				}}
				format={format || 'DD-MM-YYYY'}
				slots={{ openPickerIcon: logo.CalenderIcon }}
				{...rest}
				
				defaultValue={defaultValue ? dayjs(defaultValue) : undefined}
				className='datePicker'
			/>
		</LocalizationProvider>
	);
});

export { DatePicker };
export default DatePicker;
